import {
  getChartOfAccounts,
  accountTemplateData,
  createGLAccount,
  accountTemplateDataById,
  updateGLAccount,
  deleteGLAccount,
  getAccountingRulesList,
  getAccountingRulesTemplate,
  createAccountingRule,
  getAccountingRulesById,
  deleteRule,
  getRulesTemplateById,
  getClosingEntriesList,
  getOfficesList,
  filterClosureListByOffice,
  createClosure,
  deleteClosure,
  getClosureDataById,
  getAccountingRules,
  getCurrencyData,
  getPaymentTypes,
  addFrequentPostings,
  getAllowedAccounts,
  getFinancialActivityAccounts,
  financialActivityTemplate,
  addFinancialActivityMapping,
  deletefinancialActivityMapping,
  viewFinancialActivityDataById,
  updateFinancialActivityMapping,
  filterJournalEntriesList,
  getOpeningBalances,
  saveOpeningBalances,
  transactionDetails,
  reverseTransaction,
  updateClosure,
  editAccountingRule,
} from "@/http/accounting";

export default {
  namespaced: true,
  state: {
    chartAccountsList: [],
    accountTemplate: {},
    accountTemplateById: null,
    accountingRulesList: [],
    accountingRulesTemplate: {},
    accountingRulesById: null,
    rulesTemplateById: null,
    closingEntriesList: [],
    officesList: [],
    closureData: {},
    accountingRules: null,
    currencyData: {},
    paymentTypes: null,
    allowedAccounts: null,
    financialActivityAccounts: [],
    financialActivityTemplateData: {},
    financialActivityData: { financialActivityData: {}, glAccountData: {} },
    journalEntriesList: [],
    openingBalances: null,
    transactionDetails: null,
    reverseTransactionId: null,
  },
  actions: {
    async getChartOfAccountsAction({ commit }) {
      try {
        const resp = await getChartOfAccounts();
        commit("SET_CHART_OF_ACCOUNTS", resp.data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async accountTemplateDataAction({ commit }) {
      try {
        const resp = await accountTemplateData();
        commit("SET_ACCOUNT_TEMPLATE", resp.data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async accountTemplateDataByIdAction({ commit }, data) {
      try {
        const resp = await accountTemplateDataById(data);
        commit("SET_ACCOUNT_TEMPLATE_BY_ID", resp.data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async createGLAccountAction(_, payload) {
      try {
        const resp = await createGLAccount(payload);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async createAccountingRuleAction(_, payload) {
      try {
        const resp = await createAccountingRule(payload);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async editAccountingRuleAction(_, payload) {
      try {
        const resp = await editAccountingRule(payload.id, payload.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async deleteGLAccountAction(_, payload) {
      try {
        const resp = await deleteGLAccount(payload);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async updateGLAccountAction(_, payload) {
      try {
        const resp = await updateGLAccount(payload.id, payload.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async deleteRuleAction(_, payload) {
      try {
        const resp = await deleteRule(payload);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getAccountingRulesListAction({ commit }) {
      try {
        const resp = await getAccountingRulesList();
        commit("SET_ACCOUNTING_RULE_LIST", resp.data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getAccountingRulesByIdAction({ commit }, payload) {
      try {
        const resp = await getAccountingRulesById(payload);
        commit("SET_ACCOUNTING_RULE_BY_ID", resp.data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getRulesTemplateByIdAction({ commit }, payload) {
      try {
        const resp = await getRulesTemplateById(payload);
        commit("SET_RULES_TEMPLATE_BY_ID", resp.data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getAccountingRulesTemplateAction({ commit }) {
      try {
        const resp = await getAccountingRulesTemplate();
        commit("SET_ACCOUNTING_RULE_TEMPLATE", resp.data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getClosingEntriesListAction({ commit }) {
      try {
        const resp = await getClosingEntriesList();
        commit("SET_CLOSING_ENTRIES_LIST", resp.data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async filterClosureListByOfficeAction({ commit }, payload) {
      try {
        const resp = await filterClosureListByOffice(payload);
        commit("FILTER_CLOSING_ENTRIES_LIST", resp.data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getOfficesListAction({ commit }) {
      try {
        const resp = await getOfficesList();
        commit("SET_OFFICES_LIST", resp.data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getClosureDataByIdAction({ commit }, payload) {
      try {
        const resp = await getClosureDataById(payload);
        commit("SET_CLOSURE_DATA_BY_ID", resp.data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getAccountingRulesAction({ commit }, payload) {
      try {
        const resp = await getAccountingRules(payload);
        commit("SET_ACCOUNTING_RULES", resp.data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getCurrencyDataAction({ commit }, payload) {
      try {
        const resp = await getCurrencyData(payload);
        commit("SET_CURRENCY_DATA", resp.data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getPaymentTypesAction({ commit }) {
      try {
        const resp = await getPaymentTypes();
        commit("SET_PAYMENT_TYPES", resp.data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async addFrequentPostingsAction({ commit }, payload) {
      try {
        const resp = await addFrequentPostings(payload);
        commit("SET_REVERSE_TRANSACTION_ID", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async createClosureAction(_, payload) {
      try {
        const resp = await createClosure(payload);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async updateClosureAction(_, payload) {
      try {
        const resp = await updateClosure(payload.id, payload.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async deleteClosureAction(_, payload) {
      try {
        const resp = await deleteClosure(payload);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getAllowedAccountsAction({ commit }) {
      try {
        const resp = await getAllowedAccounts();
        commit("SET_ALLOWED_ACCOUNTS", resp.data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getFinancialActivityAccountsAction({ commit }) {
      try {
        const resp = await getFinancialActivityAccounts();
        commit("SET_FINANCIAL_ACTIVITY_ACCOUNTS", resp.data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async transactionDetailsAction({ commit }, payload) {
      try {
        const resp = await transactionDetails(payload);
        commit("SET_TRANSACTION_DETAILS", resp.data.pageItems);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async financialActivityTemplateAction({ commit }) {
      try {
        const resp = await financialActivityTemplate();
        commit("SET_FINANCIAL_ACTIVITY_TEMPLATE", resp.data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async filterJournalEntriesListAction({ commit }, payload) {
      try {
        const resp = await filterJournalEntriesList(payload);
        commit("SET_JOURNAL_ENTRIES_LIST", resp.data.pageItems);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    clearOpeningBalances({ commit }) {
      commit('CLEAR_OPENING_BALANCES');
    },
    clearJournalEntriesList({ commit }) {
      commit('CLEAR_JOURNAL_ENTRIES_LIST');
    },
    async viewFinancialActivityDataByIdAction({ commit }, payload) {
      try {
        const resp = await viewFinancialActivityDataById(payload);
        commit("SET_FINANCIAL_ACTIVITY_DATA", resp.data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getOpeningBalancesAction({ commit }, payload) {
      try {
        const resp = await getOpeningBalances(payload.currencyCode, payload.office);
        commit("SET_OPENING_BALANCES", resp.data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async addFinancialActivityMappingAction(_, payload) {
      try {
        return await addFinancialActivityMapping(payload);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async updateFinancialActivityMappingAction(_, payload) {
      try {
        return await updateFinancialActivityMapping(payload.id, payload.data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async deletefinancialActivityMappingAction(_, payload) {
      try {
        return await deletefinancialActivityMapping(payload);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async saveOpeningBalancesAction({ commit }, payload) {
      try {
        const resp = await saveOpeningBalances(payload);
        commit("SET_REVERSE_TRANSACTION_ID", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async reverseTransactionAction({ commit }, payload) {
      try {
        const resp = await reverseTransaction(payload);
        commit("SET_REVERSE_TRANSACTION_ID", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  mutations: {
    SET_CHART_OF_ACCOUNTS(state, payload) {
      state.chartAccountsList = payload;
    },
    SET_ACCOUNT_TEMPLATE(state, payload) {
      state.accountTemplate = payload;
    },
    SET_ACCOUNT_TEMPLATE_BY_ID(state, payload) {
      state.accountTemplateById = payload;
    },
    SET_ACCOUNTING_RULE_LIST(state, payload) {
      state.accountingRulesList = payload;
    },
    SET_ACCOUNTING_RULE_TEMPLATE(state, payload) {
      state.accountingRulesTemplate = payload;
    },
    SET_ACCOUNTING_RULE_BY_ID(state, payload) {
      state.accountingRulesById = payload;
    },
    SET_RULES_TEMPLATE_BY_ID(state, payload) {
      state.rulesTemplateById = payload;
    },
    SET_CLOSING_ENTRIES_LIST(state, payload) {
      state.closingEntriesList = payload;
    },
    FILTER_CLOSING_ENTRIES_LIST(state, payload) {
      state.closingEntriesList = payload;
    },
    SET_OFFICES_LIST(state, payload) {
      state.officesList = payload;
    },
    SET_CLOSURE_DATA_BY_ID(state, payload) {
      state.closureData = payload;
    },
    SET_ACCOUNTING_RULES(state, payload) {
      state.accountingRules = payload;
    },
    SET_CURRENCY_DATA(state, payload) {
      state.currencyData = payload;
    },
    SET_PAYMENT_TYPES(state, payload) {
      state.paymentTypes = payload;
    },
    SET_ALLOWED_ACCOUNTS(state, payload) {
      state.allowedAccounts = payload;
    },
    SET_FINANCIAL_ACTIVITY_ACCOUNTS(state, payload) {
      state.financialActivityAccounts = payload;
    },
    SET_FINANCIAL_ACTIVITY_TEMPLATE(state, payload) {
      state.financialActivityTemplateData = payload;
    },
    SET_FINANCIAL_ACTIVITY_DATA(state, payload) {
      state.financialActivityData = payload;
    },
    SET_JOURNAL_ENTRIES_LIST(state, payload) {
      state.journalEntriesList = payload;
    },
    SET_OPENING_BALANCES(state, payload) {
      state.openingBalances = payload;
    },
    SET_TRANSACTION_DETAILS(state, payload) {
      state.transactionDetails = payload;
    },
    SET_REVERSE_TRANSACTION_ID(state, payload) {
      state.reverseTransactionId = payload;
    },
    CLEAR_OPENING_BALANCES(state) {
      state.openingBalances = "";
    },
    CLEAR_JOURNAL_ENTRIES_LIST(state) {
      state.journalEntriesList = "";
    },
  },
};
